import React from "react";
import { useNavigate } from "react-router-dom";
import GlossaryForm from "Components/Admin/AdminOtherDetails/AdminGlossary/GlossaryForm";
import { useCreateGlossaryMutation } from "Services/GlossaryApiSlice";
import { notifications } from "@mantine/notifications";

const AdminGlossaryAdd: React.FC = () => {
  const navigate = useNavigate();
  const [createGlossary] = useCreateGlossaryMutation();

  const handleSave = async (formData: FormData) => {
    try {
      const response: any = await createGlossary(formData).unwrap();

      notifications.show({
        message: response?.message,
        color: "green",
      });

      navigate("/admin/other-details/glossary", { replace: true });

    } catch (error: any) {
      console.error("Create Glossary Error:", error);
      notifications.show({
        message: (error as any)?.data?.message || "An error occurred",
        color: "red",
      });
    }
  };

  const handleCancel = () => {
    navigate("/admin/other-details/glossary");
  };

  return (
    <div className="px-8 pt-6">
      <GlossaryForm item={null} onSave={handleSave} onCancel={handleCancel} />
    </div>
  );
};

export default AdminGlossaryAdd;
